// @ts-nocheck
/* eslint-disable */
export const llaPlatformArrowDownFullIcon = {
    data: `<svg viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.375 8.45825L6 13.0416L1.625 8.45825" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M6 12.2083V0.958252" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'arrow-down-full' as const
};